// M5 Customer Cases — data-testid registry.
export const CASES = {
  navCases: "nav-cases",

  // List
  listTable: "cases-table",
  listRow: (id) => `cases-row-${id}`,
  searchInput: "cases-search-input",
  statusFilter: "cases-status-filter",
  typeFilter: "cases-type-filter",
  priorityFilter: "cases-priority-filter",
  newBtn: "cases-new-btn",
  pagePrev: "cases-page-prev",
  pageNext: "cases-page-next",

  // Universal search on new-case screen
  searchQ: "case-search-q",
  searchBtn: "case-search-btn",
  searchCustomer: "case-search-customer",
  searchPassport: "case-search-passport",
  searchSalesOrder: "case-search-so",
  searchWarranty: "case-search-warranty",

  // New case form
  newType: "case-new-type",
  newPriority: "case-new-priority",
  newCategory: "case-new-category",
  newProblem: "case-new-problem",
  newRemarks: "case-new-remarks",
  newImageUpload: "case-new-image-upload",
  newImagePreview: (i) => `case-new-image-${i}`,
  newImageRemove: (i) => `case-new-image-remove-${i}`,
  newSubmit: "case-new-submit",
  newCancel: "case-new-cancel",

  // Detail
  detailHeader: "case-detail-header",
  detailStatus: "case-detail-status",
  detailWarranty: "case-detail-warranty",

  // Actions
  assignBtn: "case-assign-btn",
  assignSelect: "case-assign-select",
  assignSubmit: "case-assign-submit",
  inspectBtn: "case-inspect-btn",
  inspectNotes: "case-inspect-notes",
  inspectSubmit: "case-inspect-submit",
  awaitBtn: "case-await-btn",
  awaitReason: "case-await-reason",
  awaitSubmit: "case-await-submit",
  approveBtn: "case-approve-btn",
  rejectBtn: "case-reject-btn",
  decisionReason: "case-decision-reason",
  decisionSubmit: "case-decision-submit",
  repairStartBtn: "case-repair-start-btn",
  repairStartNotes: "case-repair-start-notes",
  repairStartSubmit: "case-repair-start-submit",
  repairCompleteBtn: "case-repair-complete-btn",
  repairCompleteNotes: "case-repair-complete-notes",
  repairPartAdd: "case-repair-part-add",
  repairPart: (i) => `case-repair-part-${i}`,
  repairCompleteSubmit: "case-repair-complete-submit",
  replacementBtn: "case-replacement-btn",
  replacementPassportSearch: "case-replacement-search",
  replacementPassportResult: (pid) => `case-replacement-result-${pid}`,
  replacementSubmit: "case-replacement-submit",
  closeBtn: "case-close-btn",
  closeResolution: "case-close-resolution",
  closeSubmit: "case-close-submit",

  timeline: "case-timeline",
  timelineEntry: (i) => `case-timeline-entry-${i}`,
  imageEntry: (i) => `case-image-${i}`,
};
